import {Autocomplete, FormControl, TextField, Grid, MenuItem, Select, InputLabel, FormControlLabel, Checkbox} from '@mui/material';
import React, { useState, useEffect, Fragment } from 'react';
import {useTranslation} from "react-i18next";
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_OTHER} from './SearchCommon.js';
import {brCodeList} from '../Lists.js';

export const ECO_NOT_IN_USE	= 0;
const ECO_ECO			= 1;
const ECO_NOT_ECO		= 2;

export const ecoList = [
	{id: ECO_NOT_IN_USE, eq: '-'},
	{id: ECO_ECO, eq: 'common.yes'},
	{id: ECO_NOT_ECO, eq: 'common.no'}
];

export const BR_CODE_NOT_IN_USE	= 0;
const BR_CODE_EXACTLY		= 1;
const BR_CODE_AT_LEAST		= 2;
const BR_CODE_AT_MOST		= 3;

export const brCodeEqList = [
	{id: BR_CODE_NOT_IN_USE, eq: '-'},
	{id: BR_CODE_EXACTLY, eq: '='},
	{id: BR_CODE_AT_LEAST, eq: '>='},
	{id: BR_CODE_AT_MOST, eq: '<='}
];

export const TWITCH_NOT_IN_USE	= 0;
const TWITCH_TWITCHED		= 1;
const TWITCH_NOT_TWITCHED	= 2;

export const twitchList = [
	{id: TWITCH_NOT_IN_USE, eq: '-'},
	{id: TWITCH_TWITCHED, eq: 'common.yes'},
	{id: TWITCH_NOT_TWITCHED, eq: 'common.no'}
];

function FilterOther(props) {
	const {t} = useTranslation('obs');
	const gStorage = useGlobalStorage();
	const [tripList, setTripList] = useState([]);

	useEffect(() => {
		let _tl = [];

		if (gStorage.lists.triplist && gStorage.lists.triplist.list) {
			_tl = gStorage.lists.triplist.list.filter(x => x.id !== 0);
		}

		setTripList(_tl);
		// eslint-disable-next-line
	}, []);

	function equalityList() {
		return brCodeEqList.map((code, ind) => {
			return (<MenuItem key={code.id} value={code.id}>{code.eq}</MenuItem>);
		});
	}

	function finBrCodeList() {
		return brCodeList.map((code, ind) => {
			if (ind <= 0)
				return null;

			return (<MenuItem key={code.id} value={code.id}>{code.cat.length ? t(code.name) + ', ' + t(code.short_desc) : t(code.name)}</MenuItem>);
		});
	}

	if (gStorage.main.filter.tab !== TAB_OTHER)
		return null;

	return(
		<Fragment>
			<Grid size={{xs: 12}} align={'center'}>
				<FormControl variant="outlined" style={{width: 300, margin: 8}}>
					<Autocomplete
						multiple
						size='small'
						onChange={props.tripChange}
						options={tripList}
						getOptionLabel={(dt) => dt.name}
						isOptionEqualToValue={(dt, val) => dt.id === val.id}
						defaultValue={[]}
						value={props.filter.trips}
						filterSelectedOptions
						renderInput={(params) => (
							<TextField
								{...params}
								label={t('filter.trips')}
							/>
						)}
					/>
				</FormControl>
			</Grid>

			<Grid size={{xs: 12}} align={'center'} style={{width: 300, margin: 8}}>
				<FormControl variant="outlined" size="small" align='left' style={{width: 300, margin: 0}}>
					<InputLabel style={{width: 300, margin: -8, leftMargin: 0}}>
						{t('add.fin_br_code')}
					</InputLabel>
					<Select
						value={props.filter.br_code_mask}
						onChange={props.brCodeMaskChange}
						style={{width: 96, leftMargin: 0}}>
							{equalityList()}
					</Select>
				</FormControl>
			</Grid>

			<Grid size={{xs: 12}} align={'center'}>
				<FormControl variant="outlined" size="small" align='left'>
					<Select
						disabled={props.filter.br_code_mask === BR_CODE_NOT_IN_USE}
						value={props.filter.br_code}
						onChange={props.brCodeChange}
						style={{width: 300, margin: 8}}>
							{finBrCodeList()}
					</Select>
				</FormControl>
			</Grid>

			<Grid size={{xs: 12}} align={'center'} style={{width: 300, margin: 8}}>
				<FormControl variant="outlined" size="small" align='left' style={{width: 300, margin: 0}}>
					<InputLabel style={{width: 300, margin: -8, leftMargin: 0}}>
						{t('add.eco')}
					</InputLabel>
					<Select
						value={props.filter.eco}
						onChange={props.ecoChange}
						style={{width: 300, leftMargin: 8}}>
							{ecoList.map((code, ind) => {
								return (<MenuItem key={code.id} value={code.id}>{t(code.eq)}</MenuItem>)
							})}
					</Select>
				</FormControl>
			</Grid>

			<Grid size={{xs: 12}} align={'center'} style={{width: 300, margin: 8}}>
				<FormControl variant="outlined" size="small" align='left' style={{width: 300, margin: 0}}>
					<InputLabel style={{width: 300, margin: -8, leftMargin: 0}}>
						{t('add.twitched')}
					</InputLabel>
					<Select
						value={props.filter.twitched}
						onChange={props.twitchChange}
						style={{width: 300, leftMargin: 8}}>
							{ecoList.map((code, ind) => {
								return (<MenuItem key={code.id} value={code.id}>{t(code.eq)}</MenuItem>)
							})}
					</Select>
				</FormControl>
			</Grid>

			<Grid size={{xs: 12}} align={'center'}>
				<FormControlLabel
					label={t('filter.own_obs')}
					labelPlacement="start"
					checked={props.filter.own_obs === true}
					onChange={props.ownCheck}
					control={<Checkbox color="primary" />}
					style={{margin: 0}}
				/>
			</Grid>

			<Grid size={{xs: 12}} align={'center'}>
				<FormControlLabel
					label={t('filter.no_coord')}
					labelPlacement="start"
					checked={props.filter.no_coord === true}
					onChange={props.noCoordCheck}
					control={<Checkbox color="primary" />}
					style={{margin: 0}}
				/>
			</Grid>
		</Fragment>
	);
};

export default FilterOther;
